import { trackingEvent } from '../../../analytics';
import { AMPLITUDE_SERVICE } from '../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../analytics/utils';

export const trackCalendarEditEvents = (reason, action) => {
  trackingEvent(
    'calendar_warning_shown',
    {
      ...getBasicAmplitudEventProperties(),
      event_source: 'calendar_edition',
      reason,
      ...(action && { action })
    },
    AMPLITUDE_SERVICE
  );
};

export const trackCalendarModalEvents = (action) => {
  trackingEvent(
    'mismatching_hours_modal',
    {
      ...getBasicAmplitudEventProperties(),
      action_taken: action
    },
    AMPLITUDE_SERVICE
  );
};
